module.exports = __webpack_public_path__ + "static/img/pro_defualt-img.2ae4ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/pro_defualt-img.png
// module id = AVM+
// module chunks = 1